import {ref} from 'vue';

export default {
    install: (app, options) => {
        const regions = ref([]);
        const countries = ref([]);
        const responsibleCountries = ref([]);

        const loadRegions = () => {
            if (regions.value.length === 0) {
                window.lazy_axios.get('/regions/?with=countries,responsible_countries&all=true')
                    .then((response) => {
                        if (response.data.regions) {
                            regions.value = response.data.regions;
                            countries.value = response.data.countries;
                            responsibleCountries.value = response.data.responsible_countries;
                        }
                    });
            }
        };

        app.provide('company.regions', regions);
        app.provide('company.countries', countries);
        app.provide('company.responsible_countries', responsibleCountries);
        app.provide('company.loadRegions', loadRegions);
    },
}
